export default "icons-print-demand"